'use client';
// ProgramListCard.js

/* Built In Imports */
import { useEffect, useState } from 'react';

/* External Imports */
import { Link } from '@chakra-ui/next-js';
import { Box, Button } from '@chakra-ui/react';

import YouTube from 'react-youtube';
/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@app-ps/Components/Ui/LazyLoadImageComponent';
import { refineUrlDomain } from '@app-ps/Components/Utility/utils';
import config from '@config';

import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';

/**
 *
 * @param {Object} program
 * @returns
 */
const ProgramListCard = ({ program, region, lang }) => {
  // console.log(program, 'fdff');
  const [opts, setOpts] = useState({}); // Store video options
  const [vidVis, setvidVis] = useState(false);
  useEffect(() => {
    setOpts({
      height: '100%', // Set height based on your box size
      width: '100%', // Full width of the container
      playerVars: {
        autoplay: 1, // Auto-play the video when it loads
      },
    });
  }, []);

  const onReady = e => {
    e.target.playVideo();
  };
  const videoUrl = '';

  return (
    <Box
      maxWidth={{ xl: '1097px' }}
      mx={{ xl: 'auto' }}
      // key={program.id}
      mt={{ base: '1.5rem' }}
      display={'flex'}
      flexDirection={{ lg: 'row-reverse', base: 'column' }}
      justifyContent={{ lg: 'center' }}
    >
      {/* box for photo */}
      <Box
        as={Link}
        bgSize="cover"
        bgPosition="center"
        bgImage={`url(${program?.heroImage?.url})`}
        width={{ base: '100%', md: '100%', lg: '40%' }}
        maxWidth={{ lg: '374px' }}
        height={{ base: '298px', md: '339px', lg: 'auto' }}
        display="flex"
        alignItems="center"
        justifyContent="center"
        position="relative"
        href={refineUrlDomain(program.urlAlias, region, lang)}
        prefetch
        cursor="pointer"
      >
        <Box
          display="none"
          width="100%"
          height="100%"
          position="absolute"
          top="0"
          left="0"
        >
          <YouTube
            videoId="" // Directly use the videoId
            opts={opts}
            onReady={event => event.target.playVideo()}
            style={{ width: '100%', height: '100%' }}
          />
        </Box>
        <Box
          bgColor="#090D11"
          color="#FFFFFF"
          opacity="0.7"
          textAlign="center"
          fontWeight={350}
          fontSize={{ base: '0.875rem' }}
          letterSpacing="2%"
          lineHeight={{ base: '1.4rem' }}
          p="0.5rem"
          fontFamily="var(--FedraSansStd-book)"
          position="absolute"
          top={{ base: 'auto', lg: '0rem' }}
          bottom={{ base: '0rem', lg: 'auto' }}
          left={{ base: '0rem', lg: 'auto' }}
          right={{ base: 'auto', lg: '0rem' }}
          textTransform="capitalize"
        >
          {program.venue}
        </Box>
        {videoUrl && (
          <LazyLoadImageComponent
            src={
              program?.sessionsAndDuration ||
              'https://static.sadhguru.org/d/46272/1720495733-button-play.png'
            }
            height="70px"
            width="70px"
            alt=""
          />
        )}
      </Box>

      {/* box container for all text */}
      <Box
        padding={{ base: '1rem' }}
        paddingY={{ md: '3rem' }}
        px={{ md: '2rem' }}
        bgColor={'#0E1216'}
        w={{ base: '100%', lg: '70%' }}
      >
        {/* box for text1 */}
        <Box
          as={Link}
          href={refineUrlDomain(program.urlAlias, region, lang)}
          color={'#FEFAF6'}
          letterSpacing={'0.32px'}
          textTransform="uppercase"
          fontWeight={500}
          fontSize={{ base: '1.125rem', md: '1.25rem' }}
          fontFamily={'var(--FedraSansStd-medium)'}
          _hover={{
            textDecoration: 'none',
          }}
          prefetch
        >
          {program.title}
        </Box>
        {/* box for text 2 */}
        <Box
          fontWeight={350}
          fontFamily={'var(--FedraSansStd-book)'}
          letterSpacing={'0.32px'}
          opacity={'0.8'}
          color={'#F1EDE9'}
          mt={{ base: '1rem', lg: '2rem' }}
          fontSize={{ base: '0.875rem', md: '1.125rem' }}
          lineHeight={{ md: '1.8rem', base: '1.4rem' }}
        >
          {program.summary}
        </Box>

        {/* box for text3 and button */}
        <Box
          mt={{ base: '1.5rem', lg: '5rem' }}
          display={{ base: 'flex' }}
          flexDirection={{ base: 'column', lg: 'row' }}
          justifyContent={{ lg: 'space-between' }}
          alignItems={{ lg: 'center' }}
          gap={7}
        >
          <Box
            display={'flex'}
            alignItems={'center'}
            letterSpacing={'0.32px'}
            lineHeight={{ md: '1.8rem', base: '1.4rem' }}
            fontFamily={'var(--FedraSansStd-book)'}
            color={'#FEFAF6'}
            fontSize={{ base: '0.875rem', md: '1rem' }}
          >
            <LazyLoadImageComponent
              src={`${config.imgPath}/d/46272/1723466202-icon.png`}
              objectFit={'cover'}
              objectPosition={'center'}
              width={{ base: '18px' }}
              height={{ base: '18px' }}
              mr={{ base: '.3rem', lg: '.7rem' }}
            />
            {program?.sessionsAndDuration}
          </Box>
          <Button
            px={{ base: '2rem' }}
            textAlign={'center'}
            boxSizing="border-box"
            py={{ base: '12px' }}
            bgColor={'#EDA807'}
            fontFamily={'var(--FedraSansStd-medium)'}
            borderRadius={'none'}
            _hover={{
              bgColor: '#F2C251',
              textDecoration: 'none',
            }}
            as={Link}
            fontWeight={500}
            width={{ '2xl': '201px' }}
            height={{ base: '50px' }}
            fontSize={{ base: '1rem', md: '1rem' }}
            letterSpacing={'0.32px'}
            color={'#010509'}
            href={refineUrlDomain(program.urlAlias, region, lang)}
          >
            FIND OUT MORE
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default ProgramListCard;
